import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="editable-text"
export default class extends Controller {
  static targets = ["input", "actions", "editIcon"]

  connect() {
    this.originalValue = this.inputTarget.value
  }

  startEdit() {
    this.actionsTarget.classList.remove("hidden")
    this.editIconTarget.classList.add("hidden")
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  save() {
    const form = this.inputTarget.closest("form")
    if (form) {
      form.requestSubmit()
    }
    this.hideActions()
  }

  cancel() {
    this.inputTarget.value = this.originalValue
    this.hideActions()
    this.inputTarget.blur()
  }

  hideActions() {
    this.actionsTarget.classList.add("hidden")
    this.editIconTarget.classList.remove("hidden")
  }

  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.save()
    } else if (event.key === "Escape") {
      event.preventDefault()
      this.cancel()
    }
  }
}
